/**
 * 数据源key映射
 */
export const DATASOURCE_KEY_MAP = {
  /**
   * MScience
   */
  MSCIENCE: 'mscience',
  /**
   * NPD
   */
  NPD: 'npd',
  /**
   * GSD
   */
  GSD: 'gsd',
  /**
   * Newzoo
   */
  NEWZOO: 'newzoo',
  /**
   * App Annie
   */
  APP_ANNIE: 'appannie',
  /**
   * Sensor Tower
   */
  SENSORTOWER: 'sensortower',
  /**
   * OGDB
   */
  OGDB: 'ogdb',
  /**
   * Gamalytic
   */
  GAMALYTIC: 'gamalytic',
};

/**
 * 通用指标key映射（跨数据源）
 */
export const COMMON_METRIC_KEY_MAP = {
  /**
   * Active Users指标
   */
  AU: 'au',
  /**
   * Revenue指标
   */
  REVENUE: 'revenue',
  /**
   * Download指标
   */
  DOWNLOAD: 'download',
  /**
   * ARPU指标
   */
  ARPU: 'arpu',
  /**
   * Units指标
   */
  UNITS: 'units',
};

/**
 * Sensor Tower指标key映射
 */
export const SENSORTOWER_METRIC_KEY_MAP = {
  /**
   * Active Users指标
   */
  ACTIVE_USERS: 'au',
  /**
   * Cross App Usage指标
   */
  CROSS_APP_USAGE: 'ss_cross_app_usage',
  /**
   * Cross Affinity指标
   */
  CROSS_AFFINITY: 'ss_cross_affinity',
};

/**
 * MScience指标key映射
 */
export const MSCIENCE_METRIC_KEY_MAP = {
  /**
   * Digital Revenue指标
   */
  DIGITAL_REVENUE: 'digitalRevenue',
  DIGITAL_UNITS: COMMON_METRIC_KEY_MAP.UNITS,
  DIGITAL_ARPPU: 'digitalARPPU',
  DIGITAL_AST: 'ast',
};

/**
 * NPD指标key映射
 */
export const NPD_METRIC_KEY_MAP = {
  PHYSICAL_REVENUE: COMMON_METRIC_KEY_MAP.REVENUE,
  PHYSICAL_UNITS: COMMON_METRIC_KEY_MAP.UNITS,
};

/**
 * GSD指标key映射
 */
export const GSD_METRIC_KEY_MAP = {
  /**
   * Total Revenue指标
   */
  TOTAL_REVENUE: 'gsd_totalRevenue',
  /**
   * Digital Revenue指标
   */
  DIGITAL_REVENUE: 'gsd_digitalRevenue',
  /**
   * Physical Revenue指标
   */
  PHYSICAL_REVENUE: 'gsd_physicalRevenue',
  /**
   * Total Units指标
   */
  TOTAL_UNITS: 'gsd_totalUnits',
  /**
   * Digital Units指标
   */
  DIGITAL_UNITS: 'gsd_digitalUnits',
  /**
   * Physical Units指标
   */
  PHYSICAL_UNITS: 'gsd_physicalUnits',
};

/**
 * NEWZOO指标key映射
 */
export const NEWZOO_METRIC_KEY_MAP = {
  /**
   * Total Revenue指标
   */
  TOTAL_REVENUE: 'total_revenue',
  /**
   * Total Players指标
   */
  TOTAL_PLAYERS: 'total_players',
};

/**
 * Gamalytic指标key映射
 */
export const GAMALYTIC_METRIC_KEY_MAP = {
  /**
   * Premium Revenue指标
   */
  PREMIUM_REVENUE: 'gamalytic__est_revenue',
  /**
   * Cumulative Revenue指标
   */
  CUMULATIVE_REVENUE: 'gamalytic__est_cumulative_revenue',
  /**
   * Units指标
   */
  UNITS: 'gamalytic__est_units',
  /**
   * Cumulative Units指标
   */
  CUMULATIVE_UNITS: 'gamalytic__est_cumulative_units',
  /**
   * PCU指标
   */
  PCU: 'gamalytic__pcu',
  /**
   * ACU指标
   */
  ACU: 'gamalytic__acu',
  /**
   * Followers指标
   */
  FOLLOWERS: 'gamalytic__steamfollowers',
  /**
   * Reviews指标
   */
  REVIEWS: 'gamalytic__steamreviews',
  /**
   * Price指标
   */
  PRICE: 'gamalytic__est_price',
  /**
   * Lifetime Weighted Price指标
   */
  LIFETIME_WEIGHTED_PRICE: 'gamalytic__lifetime_weighted_price',
  /**
   * Players by Country指标
   */
  PLAYERS_BY_COUNTRY: 'gamalytic__players_by_country',
  /**
   * Daily Wishlists指标
   */
  DAILY_WISHLISTS: 'gamalytic__wishlists',
  /**
   * Lifetime Wishlists指标
   */
  LIFETIME_WISHLISTS: 'gamalytic__wishlists_total',
  /**
   * Avg Playtime指标
   */
  AVG_PLAYTIME: 'gamalytic__playtime',
  /**
   * Total Followers指标
   */
  TOTAL_FOLLOWERS: 'gamalytic__steamfollowers',
};
